import {
  Environment
} from '@vodacom/web-env';

import {
  AppState,
  getStorageWithExpiry,
  isValidEncMsisdn
} from 'helpers';

import {
  CacheStrategy,
  JavascriptTypes
} from '../../../constants';

export class EmergencyProvider {

  static BASE_URL = Environment.current.apiHost;
  static STATE = AppState.with('EmergencyProvider');
  static DEFAULT_HEADERS = {
    'Accept': 'application/json',
    'Content-Type': 'application/json'
  };

  static async provisionSMS(msisdn) {

    if (!isValidEncMsisdn(msisdn)) {
      return {
        ok: false,
        error: new Error('Invalid encrypted msisdn'),
        trace: null,
        date: null,
        result: null,
        code: null,
        stamp: new Date()
      };
    }

    return EmergencyProvider.STATE.makeServiceCall(
      `${EmergencyProvider.BASE_URL}/subscription`,
      {
        method: 'POST',
        headers: {
          ...EmergencyProvider.DEFAULT_HEADERS
        },
        bodyParams: {
          'id': msisdn
        },
        cacheStrategy: CacheStrategy.NetworkFirst
      }
    )
    .then((res) => {

      if (!res?.ok) {
        return {
          ok: false,
          error: new Error('provisioning of emergency SMS error'),
          trace: null,
          date: null,
          result: null,
          code: null,
          stamp: new Date()
        };
      }

      return res;
    })
    .catch((error) => {

      return {
        ok: false,
        error: error,
        trace: null,
        date: null,
        result: null,
        code: error?.response?.status,
        stamp: new Date()
      };
    });
  }

  static async getCachedItem(key, fallback, serviceFallback) {

    const cachedItem = getStorageWithExpiry('offers', key, fallback);

    if (!cachedItem && serviceFallback && typeof serviceFallback === JavascriptTypes.Function) {
      const response = await serviceFallback();

      if (response.ok && response.result) {
        return response;
      }
    }

    return cachedItem;
  }
}